import { createSlice } from '@reduxjs/toolkit';

const collapsedFromStorage = localStorage.getItem('sidebar_collapsed');
const darkModeFromStorage = localStorage.getItem('dark_mode');

const initialState = {
  sidebarCollapsed: collapsedFromStorage ? collapsedFromStorage === 'true' : false,
  darkMode: darkModeFromStorage ? darkModeFromStorage === 'true' : false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSidebarCollapsed(state, action) {
      state.sidebarCollapsed = action.payload;
      localStorage.setItem('sidebar_collapsed', String(action.payload));
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      localStorage.setItem('sidebar_collapsed', String(state.sidebarCollapsed));
    },
    setDarkMode(state, action) {
      state.darkMode = action.payload;
      localStorage.setItem('dark_mode', String(action.payload));
    },
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
      localStorage.setItem('dark_mode', String(state.darkMode));
    },
  },
});

export const { setSidebarCollapsed, toggleSidebar, setDarkMode, toggleDarkMode } = uiSlice.actions;
export default uiSlice.reducer;
